import { render, staticRenderFns } from "./CpD_LowStockReminder.vue?vue&type=template&id=657fae5a"
import script from "./CpD_LowStockReminder.vue?vue&type=script&lang=js"
export * from "./CpD_LowStockReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports